// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"7fcb4457","260":"e594c20b","453":"6abfebd4"}[chunkId] + ".chunk.js";
};